export const LOGIN_SILENT_PARAM = "isSilent";

export type LoginCallbackParam = {
  isManualLogin: boolean;
  cleanedUrl: string | null;
};

// The auth callback appends `isSilent` to the redirect only after a successful
// login: "false" means the user went through the identity provider by hand.
export const readLoginCallbackParam = ({
  pathname,
  search,
  hash
}: Pick<Location, "pathname" | "search" | "hash">): LoginCallbackParam => {
  const params = new URLSearchParams(search);
  const value = params.get(LOGIN_SILENT_PARAM);
  if (value === null) return { isManualLogin: false, cleanedUrl: null };

  params.delete(LOGIN_SILENT_PARAM);
  const query = params.toString();
  return {
    isManualLogin: value === "false",
    cleanedUrl: pathname + (query ? `?${query}` : "") + hash
  };
};
